import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import '@etchteam/diamond-ui/composition/FormGroup/FormGroup';
import '@etchteam/diamond-ui/control/Button/Button';
import '@etchteam/diamond-ui/canvas/Section/Section';
import '@/components/composition/Wrap/Wrap';
import '@/components/control/LocationInput/LocationInput';
import tArray from '@/lib/tArray';
import StartLayout from '@/pages/start.layout';
import LocationForm from './LocationForm';
export default function StartPage() {
    const { t } = useTranslation();
    return (_jsx(StartLayout, { children: _jsx("locator-wrap", { children: _jsxs("diamond-section", { padding: "lg", children: [_jsx("h2", { children: t('start.title') }), _jsx("ul", { children: tArray('start.aside.list').map((item) => (_jsx("li", { children: item }, item))) }), _jsx("div", { className: "diamond-spacing-bottom-md", children: _jsx(LocationForm, {}) })] }) }) }));
}
